import TagManager from '@sooro-io/react-gtm-module';
import { useCallback, useEffect } from 'react';

import { getAwsRum } from '../utils/rum';

export type UseRecordErrorValues = (error: unknown) => void;

export const useRecordError = (error?: unknown): UseRecordErrorValues => {
  const recordError = useCallback((error: unknown) => {
    getAwsRum()?.recordError(error);
    TagManager.dataLayer({
      dataLayer: { event: 'exception', description: String(error) }
    });
  }, []);

  useEffect(() => {
    if (error) {
      recordError(error);
    }
  }, [error, recordError]);

  return recordError;
};
